import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledButton = styled(Link)`
  padding: 0.6em 1.25em;
  cursor: pointer;
  min-height: 1em;
  font-weight: 700;
  line-height: 1em;
  border-radius: 0.25rem;
  background-color: ${({ selected, theme }) => (selected ? theme.accent : '#fff')};
  color: ${({ selected, theme }) => (selected && theme.shouldBeWhiteOnAccent ? '#fff' : '#333')} !important;
  text-align: 'left';
  transition: 'background-color 0.5s';
  &:hover {
    ${({ selected }) => !selected && 'background-color: #e9ebee;'}
  }
`;

const HighlightLink = ({
  to, selected, content, ...rest
}) => (
  <StyledButton
    to={to}
    content={content}
    selected={selected}
    {...rest}
  >
    {content}
  </StyledButton>
);

export default HighlightLink;
